import { isDefined } from "@clipboard-health/util-ts";
import { SvgIcon, type SvgIconProps } from "@mui/material";

import AccessUnlock from "../../illustrations/AccessUnlock";
import BankGraySmall from "../../illustrations/BankGraySmall";
import BanknoteClockSmall from "../../illustrations/BanknoteClockSmall";
import BlockCalendarWithDiamond from "../../illustrations/BlockCalendarWithDiamond";
import BlockShift from "../../illustrations/BlockShift";
import Break from "../../illustrations/Break";
import BrowseShifts from "../../illustrations/BrowseShifts";
import CalendarAlert from "../../illustrations/CalendarAlert";
import CalendarAlertSmall from "../../illustrations/CalendarAlertSmall";
import CalendarGraySmall from "../../illustrations/CalendarGraySmall";
import CalendarWarning from "../../illustrations/CalendarWarning";
import Cancellation from "../../illustrations/Cancellation";
import CancelOnCall from "../../illustrations/CancelOnCall";
import Chat from "../../illustrations/Chat";
import Check from "../../illustrations/Check";
import CheckCircleWithDiamond from "../../illustrations/CheckCircleWithDiamond";
import CheckInShieldWithDiamond from "../../illustrations/CheckInShieldWithDiamond";
import CheckWarning from "../../illustrations/CheckWarning";
import CircledCrossWithExclamation from "../../illustrations/CircledCrossWithExclamation";
import ClipboardBunny from "../../illustrations/ClipboardBunny";
import ClipboardPlusStripe from "../../illustrations/ClipboardPlusStripe";
import Clock from "../../illustrations/Clock";
import ClockError from "../../illustrations/ClockError";
import ClockErrorSmall from "../../illustrations/ClockErrorSmall";
import ClockGraySmall from "../../illustrations/ClockGraySmall";
import ClockInPending from "../../illustrations/ClockInPending";
import ClockInPendingSmall from "../../illustrations/ClockInPendingSmall";
import ClockWarning from "../../illustrations/ClockWarning";
import CoinSmall from "../../illustrations/CoinSmall";
import CompleteProfile from "../../illustrations/CompleteProfile";
import DebitCardGraySmall from "../../illustrations/DebitCardGraySmall";
import DocumentApproved from "../../illustrations/DocumentApproved";
import DocumentApprovedMedium from "../../illustrations/DocumentApprovedMedium";
import DocumentApprovedSmall from "../../illustrations/DocumentApprovedSmall";
import DocumentApprovedWarm from "../../illustrations/DocumentApprovedWarm";
import DocumentRejected from "../../illustrations/DocumentRejected";
import DocumentReplace from "../../illustrations/DocumentReplace";
import DocumentReview from "../../illustrations/DocumentReview";
import DocumentReviewMedium from "../../illustrations/DocumentReviewMedium";
import DocumentReviewSmall from "../../illustrations/DocumentReviewSmall";
import DocumentUpload from "../../illustrations/DocumentUpload";
import DollarWarning from "../../illustrations/DollarWarning";
import Driving from "../../illustrations/Driving";
import DrivingError from "../../illustrations/DrivingError";
import Error from "../../illustrations/Error";
import ErrorBank from "../../illustrations/ErrorBank";
import ErrorCreditCard from "../../illustrations/ErrorCreditCard";
import Facility from "../../illustrations/Facility";
import FacilitySmall from "../../illustrations/FacilitySmall";
import Fail from "../../illustrations/Fail";
import Gift from "../../illustrations/Gift";
import GoldDiamondCloud from "../../illustrations/GoldDiamondCloud";
import HourGlass from "../../illustrations/HourGlass";
import HourglassGray from "../../illustrations/HourglassGray";
import HoursLimit from "../../illustrations/HoursLimit";
import HoursLimitSmall from "../../illustrations/HoursLimitSmall";
import Info from "../../illustrations/Info";
import InstantPay from "../../illustrations/InstantPay";
import InstantPayGraySmall from "../../illustrations/InstantPayGraySmall";
import InstantPaySmall from "../../illustrations/InstantPaySmall";
import InstantPayWarning from "../../illustrations/InstantPayWarning";
import JobWarning from "../../illustrations/JobWarning";
import KeyGraySmall from "../../illustrations/KeyGraySmall";
import LightbulbGray from "../../illustrations/LightbulbGray";
import LimitedSubstageBadge from "../../illustrations/LimitedSubstageBadge";
import Location from "../../illustrations/Location";
import LocationError from "../../illustrations/LocationError";
import LocationGraySmall from "../../illustrations/LocationGraySmall";
import MailPerson from "../../illustrations/MailPerson";
import MailWarning from "../../illustrations/MailWarning";
import MobilePhone from "../../illustrations/MobilePhone";
import NewJobs from "../../illustrations/NewJobs";
import NfcPoster from "../../illustrations/NfcPoster";
import NfcPosterAnimated from "../../illustrations/NfcPosterAnimated";
import NonInstantPay from "../../illustrations/NonInstantPay";
import Parachute from "../../illustrations/Parachute";
import ParachuteGift from "../../illustrations/ParachuteGift";
import Pay from "../../illustrations/Pay";
import PaySuccess from "../../illustrations/PaySuccess";
import PersonDestructive from "../../illustrations/PersonDestructive";
import Phone from "../../illustrations/Phone";
import PhoneCircleWithDiamond from "../../illustrations/PhoneCircleWithDiamond";
import Priority from "../../illustrations/Priority";
import PriorityPlus from "../../illustrations/PriorityPlus";
import PriorityTiers from "../../illustrations/PriorityTiers";
import QuizError from "../../illustrations/QuizError";
import QuizInverted from "../../illustrations/QuizInverted";
import QuizRequired from "../../illustrations/QuizRequired";
import QuizSuccess from "../../illustrations/QuizSuccess";
import RedWarningCloud from "../../illustrations/RedWarningCloud";
import ReferralBonus from "../../illustrations/ReferralBonus";
import RequestSent from "../../illustrations/RequestSent";
import ReviewSent from "../../illustrations/ReviewSent";
import ScallopedCheckWithStar from "../../illustrations/ScallopedCheckWithStar";
import ScallopedDiamond from "../../illustrations/ScallopedDiamond";
import ScheduledPayment from "../../illustrations/ScheduledPayment";
import ShiftBooked from "../../illustrations/ShiftBooked";
import ShiftBookedInverted from "../../illustrations/ShiftBookedInverted";
import ShiftBookedSmall from "../../illustrations/ShiftBookedSmall";
import ShiftBoost from "../../illustrations/ShiftBoost";
import ShiftProtection from "../../illustrations/ShiftProtection";
import SilverDiamondCloud from "../../illustrations/SilverDiamondCloud";
import StopWatchWarning from "../../illustrations/StopWatchWarning";
import StripeCheckmark from "../../illustrations/StripeCheckmark";
import Success from "../../illustrations/Success";
import TiersBlueLock from "../../illustrations/TiersBlueLock";
import TiersBookBlock from "../../illustrations/TiersBookBlock";
import TiersCheckCircle from "../../illustrations/TiersCheckCircle";
import TiersClock from "../../illustrations/TiersClock";
import TiersGoldLock from "../../illustrations/TiersGoldLock";
import TiersGreenLock from "../../illustrations/TiersGreenLock";
import TiersPrioritySmall from "../../illustrations/TiersPrioritySmall";
import TiersRedLock from "../../illustrations/TiersRedLock";
import TiersShiftBoost from "../../illustrations/TiersShiftBoost";
import TiersShiftLimited from "../../illustrations/TiersShiftLimited";
import TiersShiftProtection from "../../illustrations/TiersShiftProtection";
import TiersVipSupport from "../../illustrations/TiersVipSupport";
import TiersWindowedOut from "../../illustrations/TiersWindowedOut";
import { type SvgExtendedProps } from "../../illustrations/types";
import Undo from "../../illustrations/Undo";
import Unlock from "../../illustrations/Unlock";
import UnlockSmall from "../../illustrations/UnlockSmall";
import Warning from "../../illustrations/Warning";
import { mergeSxProps } from "../../lib/mergeSxProps";
import { prefersReducedMotion } from "../../utils/prefersReducedMotion";

export const ILLUSTRATION_TYPES = [
  "bank-gray-small",
  "banknote-clock-small",
  "block-calendar-with-diamond",
  "break",
  "calendar-alert",
  "calendar-alert-small",
  "calendar-gray-small",
  "calendar-warning",
  "cancellation",
  "cancel-on-call",
  "chat",
  "circled-cross-with-exclamation",
  "check-circle-with-diamond",
  "check-in-shield-with-diamond",
  "clipboard-bunny",
  "clipboard-plus-stripe",
  "clock",
  "clock-warning",
  "clock-error",
  "clock-error-small",
  "clock-gray-small",
  "clock-in-pending",
  "clock-in-pending-small",
  "complete-profile",
  "debit-card-gray-small",
  "document-approved",
  "document-approved-medium",
  "document-approved-small",
  "document-approved-warm",
  "document-rejected",
  "document-replace",
  "document-review",
  "document-review-medium",
  "document-review-small",
  "document-upload",
  "dollar-warning",
  "driving",
  "driving-error",
  "facility",
  "facility-small",
  "fail",
  "gold-diamond-cloud",
  "hour-glass",
  "hourglass-gray",
  "hours-limit",
  "hours-limit-small",
  "info",
  "instant-pay",
  "instant-pay-gray-small",
  "instant-pay-small",
  "instant-pay-warning",
  "key-gray-small",
  "lightbulb-gray",
  "location",
  "location-error",
  "location-gray-small",
  "mobile-phone",
  "non-instant-pay",
  "pay",
  "pay-success",
  "referral-bonus",
  "phone",
  "phone-circle-with-diamond",
  "quiz-error",
  "quiz-inverted",
  "quiz-required",
  "quiz-success",
  "red-warning-cloud",
  "request-sent",
  "review-sent",
  "scalloped-check-with-star",
  "scalloped-diamond",
  "scheduled-payment",
  "silver-diamond-cloud",
  "shift-booked",
  "shift-booked-inverted",
  "shift-booked-small",
  "shift-boost",
  "stop-watch-warning",
  "stripe-checkmark",
  "success",
  "tiers-blue-lock",
  "tiers-book-block",
  "tiers-check-circle",
  "tiers-clock",
  "tiers-gold-lock",
  "tiers-green-lock",
  "tiers-priority-small",
  "tiers-red-lock",
  "tiers-shift-boost",
  "tiers-shift-limited",
  "tiers-shift-protection",
  "tiers-windowed-out",
  "tiers-vip-support",
  "undo",
  "unlock",
  "unlock-small",
  "browse-shifts",
  "block-shift",
  "error",
  "error-bank",
  "error-credit-card",
  "priority",
  "priority-plus",
  "priority-tiers",
  "mail-warning",
  "mail-person",
  "person-destructive",
  "new-jobs",
  "nfc-poster",
  "nfc-poster-animated",
  "shift-protection",
  "warning",
  "warning-solid-error",
  "coin-small",
  "limited-substage-badge",
  "gift-blue",
  "gift-lavender",
  "access-unlock",
  "check",
  "check-warning",
  "job-warning",
  "parachute-blue",
  "parachute-orange",
  "parachute-gift",
] as const;

export type IllustrationType = (typeof ILLUSTRATION_TYPES)[number];

const illustrationMap: Record<
  IllustrationType,
  {
    component: React.ForwardRefExoticComponent<
      Omit<SvgExtendedProps, "ref"> & React.RefAttributes<SVGSVGElement>
    >;
    width: number;
    height: number;
    strokeColor?: string;
    gradientStartColor?: string;
    gradientEndColor?: string;
  }
> = {
  "bank-gray-small": { component: BankGraySmall, width: 52, height: 52 },
  "banknote-clock-small": {
    component: BanknoteClockSmall,
    width: 50,
    height: 50,
  },
  "block-calendar-with-diamond": {
    component: BlockCalendarWithDiamond,
    width: 62,
    height: 54,
  },
  break: { component: Break, width: 176, height: 120 },
  "calendar-alert": { component: CalendarAlert, width: 120, height: 120 },
  "calendar-alert-small": {
    component: CalendarAlertSmall,
    width: 68,
    height: 68,
  },
  "calendar-gray-small": {
    component: CalendarGraySmall,
    width: 52,
    height: 52,
  },
  "calendar-warning": { component: CalendarWarning, width: 176, height: 120 },
  cancellation: { component: Cancellation, width: 176, height: 120 },
  "cancel-on-call": { component: CancelOnCall, width: 177, height: 120 },
  chat: { component: Chat, width: 176, height: 120 },
  "check-circle-with-diamond": {
    component: CheckCircleWithDiamond,
    width: 62,
    height: 54,
  },
  "check-in-shield-with-diamond": {
    component: CheckInShieldWithDiamond,
    width: 108,
    height: 109,
  },
  "circled-cross-with-exclamation": {
    component: CircledCrossWithExclamation,
    width: 79,
    height: 79,
  },
  "clipboard-bunny": { component: ClipboardBunny, width: 176, height: 178 },
  "clipboard-plus-stripe": {
    component: ClipboardPlusStripe,
    width: 138,
    height: 70,
  },
  clock: { component: Clock, width: 176, height: 120 },
  "clock-warning": { component: ClockWarning, width: 176, height: 120 },
  "clock-error": { component: ClockError, width: 176, height: 120 },
  "clock-error-small": { component: ClockErrorSmall, width: 100, height: 68 },
  "clock-gray-small": { component: ClockGraySmall, width: 52, height: 52 },
  "clock-in-pending": { component: ClockInPending, width: 176, height: 120 },
  "clock-in-pending-small": {
    component: ClockInPendingSmall,
    width: 100,
    height: 68,
  },
  "complete-profile": { component: CompleteProfile, width: 176, height: 120 },
  "debit-card-gray-small": {
    component: DebitCardGraySmall,
    width: 52,
    height: 52,
  },
  "document-approved": { component: DocumentApproved, width: 176, height: 120 },
  "document-approved-medium": {
    component: DocumentApprovedMedium,
    width: 100,
    height: 100,
  },
  "document-approved-small": {
    component: DocumentApprovedSmall,
    width: 60,
    height: 60,
  },
  "document-approved-warm": {
    component: DocumentApprovedWarm,
    width: 176,
    height: 120,
  },
  "document-rejected": { component: DocumentRejected, width: 176, height: 120 },
  "document-replace": { component: DocumentReplace, width: 176, height: 120 },
  "document-review": { component: DocumentReview, width: 176, height: 120 },
  "document-review-medium": {
    component: DocumentReviewMedium,
    width: 100,
    height: 100,
  },
  "document-review-small": {
    component: DocumentReviewSmall,
    width: 60,
    height: 60,
  },
  "document-upload": { component: DocumentUpload, width: 176, height: 120 },
  "dollar-warning": { component: DollarWarning, width: 176, height: 120 },
  driving: { component: Driving, width: 176, height: 120 },
  "driving-error": { component: DrivingError, width: 176, height: 120 },
  facility: { component: Facility, width: 176, height: 120 },
  "facility-small": { component: FacilitySmall, width: 60, height: 60 },
  fail: { component: Fail, width: 176, height: 120 },
  "gold-diamond-cloud": {
    component: GoldDiamondCloud,
    width: 102,
    height: 101,
  },
  "hour-glass": { component: HourGlass, width: 176, height: 120 },
  "hourglass-gray": { component: HourglassGray, width: 151, height: 150 },
  "hours-limit": { component: HoursLimit, width: 176, height: 120 },
  "hours-limit-small": { component: HoursLimitSmall, width: 100, height: 68 },
  info: { component: Info, width: 176, height: 120 },
  "instant-pay": { component: InstantPay, width: 176, height: 120 },
  "instant-pay-gray-small": {
    component: InstantPayGraySmall,
    width: 52,
    height: 52,
  },
  "instant-pay-small": { component: InstantPaySmall, width: 50, height: 50 },
  "instant-pay-warning": {
    component: InstantPayWarning,
    width: 176,
    height: 120,
  },
  "key-gray-small": { component: KeyGraySmall, width: 52, height: 52 },
  "lightbulb-gray": { component: LightbulbGray, width: 66, height: 100 },
  location: { component: Location, width: 176, height: 120 },
  "location-error": { component: LocationError, width: 176, height: 120 },
  "location-gray-small": {
    component: LocationGraySmall,
    width: 52,
    height: 52,
  },
  "mobile-phone": { component: MobilePhone, width: 177, height: 120 },
  "non-instant-pay": { component: NonInstantPay, width: 176, height: 120 },
  pay: { component: Pay, width: 176, height: 120 },
  "pay-success": { component: PaySuccess, width: 176, height: 120 },
  "referral-bonus": { component: ReferralBonus, width: 176, height: 120 },
  phone: { component: Phone, width: 176, height: 120 },
  "phone-circle-with-diamond": {
    component: PhoneCircleWithDiamond,
    width: 62,
    height: 51,
  },
  priority: { component: Priority, width: 176, height: 120 },
  "priority-plus": { component: PriorityPlus, width: 176, height: 120 },
  "quiz-error": { component: QuizError, width: 176, height: 120 },
  "quiz-inverted": { component: QuizInverted, width: 176, height: 120 },
  "quiz-required": { component: QuizRequired, width: 176, height: 120 },
  "quiz-success": { component: QuizSuccess, width: 176, height: 120 },
  "red-warning-cloud": { component: RedWarningCloud, width: 102, height: 102 },
  "request-sent": { component: RequestSent, width: 176, height: 120 },
  "review-sent": { component: ReviewSent, width: 176, height: 120 },
  "scalloped-check-with-star": {
    component: ScallopedCheckWithStar,
    width: 91,
    height: 89,
  },
  "scalloped-diamond": { component: ScallopedDiamond, width: 87, height: 87 },
  "scheduled-payment": { component: ScheduledPayment, width: 176, height: 120 },
  "silver-diamond-cloud": {
    component: SilverDiamondCloud,
    width: 101,
    height: 101,
  },
  "shift-booked": { component: ShiftBooked, width: 176, height: 120 },
  "shift-booked-inverted": {
    component: ShiftBookedInverted,
    width: 176,
    height: 120,
  },
  "shift-booked-small": { component: ShiftBookedSmall, width: 100, height: 68 },
  "shift-boost": { component: ShiftBoost, width: 176, height: 120 },
  "stop-watch-warning": { component: StopWatchWarning, width: 100, height: 68 },
  "stripe-checkmark": { component: StripeCheckmark, width: 120, height: 120 },
  success: { component: Success, width: 176, height: 120 },
  "tiers-blue-lock": { component: TiersBlueLock, width: 55, height: 54 },
  "tiers-book-block": { component: TiersBookBlock, width: 62, height: 54 },
  "tiers-check-circle": { component: TiersCheckCircle, width: 62, height: 54 },
  "tiers-clock": { component: TiersClock, width: 62, height: 54 },
  "tiers-gold-lock": { component: TiersGoldLock, width: 55, height: 54 },
  "tiers-green-lock": { component: TiersGreenLock, width: 55, height: 54 },
  "tiers-priority-small": {
    component: TiersPrioritySmall,
    width: 61,
    height: 54,
  },
  "tiers-red-lock": { component: TiersRedLock, width: 55, height: 54 },
  "tiers-shift-boost": { component: TiersShiftBoost, width: 100, height: 90 },
  "tiers-shift-limited": {
    component: TiersShiftLimited,
    width: 124,
    height: 109,
  },
  "tiers-shift-protection": {
    component: TiersShiftProtection,
    width: 59,
    height: 59,
  },
  "tiers-vip-support": { component: TiersVipSupport, width: 62, height: 54 },
  undo: { component: Undo, width: 176, height: 120 },
  unlock: { component: Unlock, width: 176, height: 120 },
  "unlock-small": { component: UnlockSmall, width: 60, height: 60 },
  "browse-shifts": { component: BrowseShifts, width: 176, height: 120 },
  "block-shift": { component: BlockShift, width: 176, height: 120 },
  error: { component: Error, width: 176, height: 120 },
  "error-bank": { component: ErrorBank, width: 176, height: 120 },
  "error-credit-card": { component: ErrorCreditCard, width: 176, height: 120 },
  "mail-person": { component: MailPerson, width: 176, height: 120 },
  "person-destructive": {
    component: PersonDestructive,
    width: 177,
    height: 120,
  },
  "new-jobs": { component: NewJobs, width: 176, height: 120 },
  "nfc-poster": { component: NfcPoster, width: 265, height: 180 },
  "nfc-poster-animated": {
    component: NfcPosterAnimated,
    width: 265,
    height: 180,
  },
  "shift-protection": { component: ShiftProtection, width: 176, height: 120 },
  warning: { component: Warning, width: 176, height: 120 },
  "warning-solid-error": {
    component: Warning,
    width: 176,
    height: 120,
    gradientStartColor: "#EF6D6E",
    gradientEndColor: "#EF6D6E",
  },
  "coin-small": { component: CoinSmall, width: 60, height: 60 },
  "limited-substage-badge": {
    component: LimitedSubstageBadge,
    width: 87,
    height: 87,
  },
  "priority-tiers": { component: PriorityTiers, width: 150, height: 118 },
  "tiers-windowed-out": {
    component: TiersWindowedOut,
    width: 124,
    height: 118,
  },
  "job-warning": { component: JobWarning, width: 176, height: 120 },
  "access-unlock": { component: AccessUnlock, width: 176, height: 120 },
  check: { component: Check, width: 176, height: 120 },
  "check-warning": { component: CheckWarning, width: 100, height: 68 },
  "gift-blue": {
    component: Gift,
    width: 50,
    height: 50,
    gradientStartColor: "#98CCFB",
  },
  "gift-lavender": {
    component: Gift,
    width: 50,
    height: 50,
    gradientStartColor: "#D7D4FF",
  },
  "mail-warning": { component: MailWarning, width: 176, height: 120 },
  "parachute-blue": {
    component: Parachute,
    width: 176,
    height: 120,
    gradientStartColor: "#98CCFB",
  },
  "parachute-orange": {
    component: Parachute,
    width: 176,
    height: 120,
    gradientStartColor: "#FFE3C3",
  },
  "parachute-gift": { component: ParachuteGift, width: 176, height: 120 },
} as const;

export interface IllustrationProps extends SvgIconProps {
  type: IllustrationType;
}

export function Illustration(props: IllustrationProps) {
  const { type, sx, ...restProps } = props;

  // Check user preference for reduced motion to disable animations
  const disableAnimations = prefersReducedMotion();

  const illustrationDefinition = illustrationMap[type];
  const {
    component: IllustrationComponent,
    width,
    height,
    ...extendedProps
  } = illustrationDefinition;

  if (!isDefined(illustrationDefinition)) {
    return null;
  }

  return (
    <SvgIcon
      {...restProps}
      inheritViewBox
      sx={mergeSxProps(sx, {
        width,
        height,
      })}
    >
      <IllustrationComponent {...extendedProps} disableAnimations={disableAnimations} />
    </SvgIcon>
  );
}
